import React, {Component, Fragment} from "react";
import TimeInput from "./TimeInput";
import './TimeTrackingField.scss'

export function minutesToFormatted(minutes) {
  let hours = Math.floor(minutes/60);
  let min = minutes - (hours * 60);

  let format = [];
  if(hours) {
    format.push(`${hours}h`)
  }
  if(min) {
    format.push(`${Math.round(min)}m`)
  }

  if(!format.length) {
    return "0h"
  }

  return format.join(' ')
}
class TimeTrackingField extends Component {

  constructor(props) {
    super(props);

    this.state = {
      total: 0,
      segments: {}
    }
  }

  componentDidMount() {
    this.setState({
      segments: this.props.value.segments ? this.props.value.segments.reduce((acc, s) => ({...acc, [s.category]: s.time}), {}): {},
      total: this.props.value.total || 0
    }, () => this.onInput())

  }

  handleTotal(val) {
   this.setState({
     total: val
   }, () => this.onInput())
  }

  handleSegment(val, c) {
    this.setState({segments: {...this.state.segments, [c]: val}}, () => this.onInput())
  }

  onInput() {
    this.props.onValueChange && this.props.onValueChange(this.props.name, {
      total: this.state.total,
      segments: Object.keys(this.state.segments).map(key => ({category: key, time: this.state.segments[key]})),
      isValid: true
    });
  }

  render() {
    const {isEdit, element = {categories: [], form_title: "Time tracking"}} = this.props;
    return (
      <div className="time-tracking-field">

        {isEdit ? (
          <Fragment>
            <div className="time-category time-category-title">{element.form_title}</div>
            {(element.categories || []).map(c => (
              <Fragment>
                <div className="time-category">{c}:</div>
                <TimeInput value={this.state.segments[c]} onInput={(val) => this.handleSegment(val, c)}/>
              </Fragment>
            ))}
            <div className="time-category">Training time: </div>
            <TimeInput value={this.state.total} onInput={(val) => this.handleTotal(val)}/>
          </Fragment>
        ): (
          <div style={{padding: '10px 30px'}}>
            <div className="time-category time-category-title">{element.form_title}</div>
            {(element.categories || []).map(c => (
              <div className="time-category">{c}: {minutesToFormatted(this.state.segments[c])}</div>
            ))}
            <div className="time-category">Training time: {minutesToFormatted(this.state.total)}</div>
          </div>
        )}

      </div>
    )
  }
}

export default TimeTrackingField
